<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="车牌号/车辆品牌/车辆行驶证号/承运商搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add'
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
            
            <b-button
              v-allow="'actImport'"
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="openImportPage"
            >
              <b-icon-cursor></b-icon-cursor>导入
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-form-item label="车牌号">
            <el-col :span="24">
              <el-input
                v-model="form.vehicleNo"
                placeholder="请输入车牌号"
                clearable
                size="small"
              >
              </el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="载重">
            <el-col :span="24">
              <el-input-number
                style="width:100%"
                v-model="form.vehicleLoad"
                controls-position="right"
                placeholder="请输入载重量"
                :min="0"
                :step="10"
                :precision="0"
                clearable
                size="small"
              >
              </el-input-number>
            </el-col>
          </el-form-item>

          <el-form-item label="车辆归属">
            <el-col :span="24">
              <dict-select
                filterable
                clearable
                v-model="form.vehicleOwnerType"
                placeholder="请选择车辆归属"
                default
                :body="{ type: 'vehicleOwnerType' }"
              >
              </dict-select>
            </el-col>
          </el-form-item>

          <el-form-item label="可用状态">
            <el-col :span="24">
              <el-checkbox-group v-model="form.vehicleStatusList">
                <el-checkbox label="Y" name="type">有效</el-checkbox>
                <el-checkbox label="N" name="type">无效</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  vehicleStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面
    openEditPage({ pageType, code = '' }) {
      this.$router.push({
        name: 'master-vehicle-detail',
        params: { code, pageType }
      })
    },
    //打开导入页面
    openImportPage(){
      this.$router.push({
        name: 'master-vehicle-import',
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
